import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { SizeGuide } from '@thd-olt-component-react/size-guide';
import { AttributeLabelModal } from './attribute-label-modal';
import { isDocumentExists } from '../../utils';

const { arrayOf, string, shape, bool } = proptypes;

export const AttributeLabel = (
  {
    attributeName,
    attributeLabelValue = '',
    brandName = '',
    hexColor = '',
    info = {
      paintBrand: ''
    },
    paintType = '',
    isPaintReorder = false,
    sizeGuideInfo = {
      collectionId: '',
      isSize: false,
      isTowelSize: false,
      parentId: '',
      productType: '',
      superSkuSizeAndFitDetail: {}
    },
    containerSizeHref = ''
  }
) => {
  const {
    parentId,
    collectionId,
    itemId,
    superSkuSizeAndFitDetail = {},
    itemSizeAndFitDetail = {}
  } = sizeGuideInfo || {};

  const hasSizeGuideAttributeGroups = !!itemSizeAndFitDetail?.attributeGroups?.length;

  const hasSizeGuide = () => {
    return attributeName?.toLowerCase() === 'size' && hasSizeGuideAttributeGroups;
  };

  const productType = itemSizeAndFitDetail?.attributeGroups?.[0]?.productType;
  const superSkuIdOrItemId = hasSizeGuideAttributeGroups ? parentId : itemId;
  const sizeGuideItemId = collectionId || superSkuIdOrItemId;
  const isWallPaint = info?.paintFamily === 'Wall Paint';
  const isPipCalculator = !!info?.pipCalculator;
  const showAttributeModal = isPaintReorder ? isWallPaint : !!info?.dotComColorEligible;
  const isContainerSize = attributeName?.toLowerCase() === 'container size';

  const scrollToWallAreaCalculator = (event) => {
    event.preventDefault();
    if (isDocumentExists()) {
      let wallAreaCalculator = document.getElementById(containerSizeHref);
      /* eslint-disable no-unused-expressions */
      wallAreaCalculator?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }
  };

  return (
    <div className="sui-flex sui-mb-2 sui-w-full sui-items-center">
      <div className="sui-flex sui-mr-2 sui-mt-2">
        <Typography variant="body-base">{attributeName}</Typography>
        <span className="sui-mr-1 sui-text-base">:</span>
        {attributeLabelValue
          && <Typography variant="body-base" weight="bold" className="sui-mx-1">{attributeLabelValue}</Typography>}
      </div>
      {hasSizeGuide() && (
        <div className="sui-ml-1">
          <SizeGuide
            itemId={sizeGuideItemId}
            productType={productType}
            isSuperSku={!collectionId}
            isCollection={!!collectionId}
            superSkuSizeAndFitDetail={superSkuSizeAndFitDetail}
            itemSizeAndFitDetail={itemSizeAndFitDetail}
          />
        </div>
      )}
      {showAttributeModal && !isContainerSize && (
        <AttributeLabelModal
          attributeName={attributeName}
          hexColor={hexColor}
          brandName={brandName}
          type={paintType}
        />
      )}
      {isContainerSize && isPipCalculator && (
        <div className="sui-ml-3 sui-mt-2 sui-whitespace-nowrap">
          <button
            type="button"
            className="sui-h-6 sui-flex sui-flex-row sui-gap-1"
            onClick={scrollToWallAreaCalculator}
          >
            <span
              data-testid="container-size-link"
              className="sui-text-base sui-text-primary sui-underline"
            >
              Help Me Choose
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

AttributeLabel.displayName = 'AttributeLabel';

AttributeLabel.propTypes = {
  attributeName: string.isRequired,
  attributeLabelValue: string,
  brandName: string,
  hexColor: string,
  info: shape({
    paintBrand: string,
    paintFamily: string
  }),
  isPaintReorder: bool,
  paintType: string,
  sizeGuideInfo: shape({
    collectionId: string,
    itemSizeAndFitDetail: shape({
      attributeGroups: arrayOf(shape({}))
    }),
    parentId: string,
    productType: string,
    superSkuSizeAndFitDetail: shape({
      attributeGroups: arrayOf(shape({}))
    })
  }),
  containerSizeHref: string
};
